import { BigNumber } from 'ethers'
import { ABI } from '../../abi'
import {
  IArgDict,
  IEditionMintStrategy,
  IPrivateMintFunctionArgs,
  IPublicMintFunctionArgs
} from './IEditionMintStrategy'

class Kits721MintStrategy implements IEditionMintStrategy {
  getAbi() {
    return ABI.ERC721Generic
  }
  getPublicMintFunctionName(): string {
    return 'purchase'
  }
  getPublicMintFunctionArgsDict({
    currentWalletAddress,
    mintCount
  }: IPublicMintFunctionArgs): IArgDict[] {
    return [
      { name: 'recipient', value: currentWalletAddress },
      { name: 'quantity', value: mintCount }
    ]
  }

  getPresaleMintFunctionName(): string {
    return 'purchasePresale'
  }

  getPresaleMintFunctionArgsDicts({
    currentWalletAddress,
    mintCount,
    maxPurchasablePerWallet,
    preSalePrice,
    merkleProof
  }: IPrivateMintFunctionArgs): IArgDict[] {
    return [
      { name: 'recipient', value: currentWalletAddress },
      { name: 'quantity', value: mintCount },
      { name: 'maxQuantity', value: maxPurchasablePerWallet },
      { name: 'pricePerToken', value: BigNumber.from(preSalePrice) },
      { name: 'merkleProof', value: merkleProof || [] }
    ]
  }

  getMintTotalFunctionName(): string {
    return 'saleDetails'
  }
  getMintTotalArgs(): any[] | undefined {
    return undefined
  }
  getMintTotalsFromData(data: any): { totalMinted: number; presaleMinted: number } {
    return {
      totalMinted: data[9].toNumber(),
      presaleMinted: data[10].toNumber()
    }
  }
}

export default new Kits721MintStrategy()
